import { memo, useEffect, useState, useRef } from "react"

import ProductService from "@/services/product"
import { Stack, Text, Image, AspectRatio, Center, Button, Container, Box, Table, IconButton, Input, Card, VStack, HStack, Separator, Heading } from "@chakra-ui/react"

import { formatCurrency } from "@/utilities/number"
import { LuPencil } from "react-icons/lu"

import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"

import ProfileService from "services/profile"
import { useNavigate, useParams, useSearchParams } from "react-router"
import WithLoginPage from "@/components/withlogin"
import moment from "moment";
import { useAuth } from "contexts/auth";
const service = new ProfileService();

const PointPage = () => {

    const { setProcessing, setPageTitle, showToast } = useApp();
    const [profile, setProfile] = useState({})
    const { user } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        setPageTitle("Điểm thưởng")
    }, [setPageTitle])

    useEffect(() => {

        load();
    }, [])


    const load = async () => {
        var a = await service.get();
        setProfile(a);
    }











    return (
        <div style={{ paddingBottom: 75 }}>

            <div >

                <Card.Root size="sm">

                    <Card.Body color="fg.muted">

                        <AspectRatio ratio={2 / 1}>
                            <Stack>
                                <Center fontSize="xl">{ formatCurrency(profile.point?.current)}</Center>
                                <Center fontSize="xl">xu</Center>
                                <Center fontSize="sm">Xu có thể dùng thanh toán hoặc đổi voucher</Center>
                            </Stack>

                        </AspectRatio>

                    </Card.Body>
                </Card.Root>




            </div>



        </div >
    )
}

const withLogin = () => (<WithLoginPage><PointPage></PointPage></WithLoginPage>)


export default memo(withLogin)